<template>
    <tr
        class="table-list__row"
        :class="{
            'table-list__row--paid': (playerPay || playerFree) && !isRefunded,
            'table-list__row--not__paid': !playerPay && !playerFree && !isRefunded,
            'table-list__row--refunded': isRefunded,
            'table-list__row--active': hover,
        }"
        @mouseover="hover = true"
        @mouseleave="hover = false"
    >
        <td
            v-for="(header, column) in headersDefault"
            :key="column"
            class="table-list__data"
            :class="{
                'table-list__data--first-cell': header.value === 'playerNumber',
                'table-list__data--min-width': header.value === 'playerChip',
                'table-list__data--max-width': header.value === 'playerGpsNumber',
                'table-list__data--lp': header.value === 'ordinalNumber',
                'table-list__data--pay': header.value === 'pay',
            }"
            @click="userDetails(item, header.value)"
        >
            <template v-if="header.value === 'ordinalNumber'">
                {{ lp + 1 }}
            </template>
            <template v-else-if="header.value === 'playerNumber'">
                <form
                    v-if="hover || index === openedIndex || isMobile"
                    @submit.prevent="updatePlayer({ id: item.id, playerNumber })"
                >
                    <div class="inputWrap">
                        <input v-model="playerNumber" />
                        <button
                            v-show="!isMobile"
                            :class="{
                                accepted: state_number.accepted,
                                wrong: state_number.wrong,
                            }"
                        >
                            <i v-if="state_number.submitted" class="fas fa-spinner"></i>
                            <i v-else-if="state_number.accepted" class="fas fa-check"></i>
                            <i v-else-if="state_number.wrong" class="fas fa-exclamation-triangle"></i>
                            <i v-else class="fas fa-check-circle"></i>
                        </button>
                    </div>
                </form>
                <span v-else-if="!item['playerNumber']">-</span>
                <span v-else>{{ item['playerNumber'] }}</span>
            </template>
            <template v-else-if="header.value === 'payLink'">
                <span v-if="playerFree"></span>
                <div v-else class="btn">
                    <img src="../assets/images/icons/link.svg" style="margin-right: 4px" /> Kopiuj link
                </div>
            </template>
            <div v-else-if="header.value === 'pay'" class="flex-wrap" @click.stop>
                <div v-if="playerFree" class="btn" style="cursor: default">
                    <span class="yes"><i class="fas fa-check-circle"></i> Bezpłatne</span>
                </div>
                <div v-else-if="isRefunded" class="btn refunded" style="cursor: default">
                    <span class="refunded">
                        <img src="../assets/images/icons/refund-zl.svg" class="refund-icon" alt="" />
                        Zwrot opłaty
                    </span>
                </div>
                <template v-else>
                    <panel-input-switch-mini v-if="isMobile" :value="playerPay" @input="onPayInput" />
                    <div
                        v-else
                        class="btn"
                        :class="{ active: hover || index === openedIndex, yes: playerPay, no: !playerPay }"
                        @click="togglePay"
                    >
                        <span v-if="playerPay" class="yes"><i class="fas fa-check-circle"></i> Opłacony</span>
                        <span v-else class="no"><i class="fas fa-times-circle"></i> Nieopłacony</span>
                    </div>
                </template>
            </div>
            <div v-else-if="header.value === 'payNumber'" class="flex-wrap" @click.stop>
                <panel-input-switch-mini v-if="isMobile" :value="playerpayNumber" @input="onPayNumberInput" />
                <div
                    v-else
                    class="btn"
                    :class="{ active: hover || index === openedIndex, yes: playerpayNumber, no: !playerpayNumber }"
                    @click="togglePayNumber"
                >
                    <span v-if="playerpayNumber" class="yes"><i class="fas fa-check-circle"></i> Opłacony</span>
                    <span v-else class="no"><i class="fas fa-times-circle"></i> Nieopłacony</span>
                </div>
            </div>
            <div v-else-if="header.value === 'isAnonymous'" class="flex-wrap" @click.stop>
                <panel-input-switch-mini v-if="isMobile" :value="playerisAnonymous" @input="onIsAnonymousInput" />
                <div
                    v-else
                    class="btn"
                    :class="{ active: hover || index === openedIndex, yes: playerisAnonymous, no: !playerisAnonymous }"
                    @click="toggleIsAnonymous"
                >
                    <span v-if="playerisAnonymous" class="yes"><i class="fas fa-check-circle"></i> Anonimowy</span>
                    <span v-else class="no"><i class="fas fa-times-circle"></i> Nieanonimowy</span>
                </div>
            </div>
            <template v-else-if="header.value === 'playerChip'">
                <form
                    v-if="hover || index === openedIndex || isMobile"
                    @submit.prevent="updatePlayer({ id: item.id, playerChip })"
                >
                    <div class="inputWrap">
                        <input v-model="playerChip" />
                        <button
                            v-show="!isMobile"
                            :class="{
                                accepted: state_chip.accepted,
                                wrong: state_chip.wrong,
                            }"
                        >
                            <i v-if="state_chip.submitted" class="fas fa-spinner"></i>
                            <i v-else-if="state_chip.accepted" class="fas fa-check"></i>
                            <i v-else-if="state_chip.wrong" class="fas fa-exclamation-triangle"></i>
                            <i v-else class="fas fa-check-circle"></i>
                        </button>
                    </div>
                </form>
                <span v-else class="ellipis">{{ item['playerChip'] }}</span>
            </template>
            <template v-else-if="header.value === 'playerGpsNumber'">
                <form
                    v-if="hover || index === openedIndex || isMobile"
                    @submit.prevent="updatePlayer({ id: item.id, playerGpsNumber: Number(playerGpsNumber) })"
                >
                    <div class="inputWrap">
                        <input v-model="playerGpsNumber" style="max-width: 68px" />
                        <button
                            v-show="!isMobile"
                            :class="{
                                accepted: state_gps.accepted,
                                wrong: state_gps.wrong,
                            }"
                        >
                            <i v-if="state_gps.submitted" class="fas fa-spinner"></i>
                            <i v-else-if="state_gps.accepted" class="fas fa-check"></i>
                            <i v-else-if="state_gps.wrong" class="fas fa-exclamation-triangle"></i>
                            <i v-else class="fas fa-check-circle"></i>
                        </button>
                    </div>
                </form>
                <span v-else class="ellipis">{{ item['playerGpsNumber'] }}</span>
            </template>
            <template v-else-if="typeof header.value === 'number'">
                <div v-html="playerInputs(header.value)"></div>
            </template>
            <template v-else-if="header.value === 'status'">
                <template v-if="playerStatus === 0 || playerStatus === 1">
                    <div @click.stop>
                        <panel-input-switch-mini
                            v-if="isMobile"
                            :value="playerStatus"
                            :true-value="0"
                            :false-value="1"
                            @input="onStatusInput"
                        />
                        <div
                            v-else
                            class="btn"
                            :class="{
                                active: hover || index === openedIndex,
                                yes: playerStatus === 0,
                                no: playerStatus === 1,
                            }"
                            @click="toggleStatus"
                        >
                            <span v-if="playerStatus === 0" class="yes"
                                ><i class="fas fa-check-circle"></i> Udział</span
                            >
                            <span v-else-if="playerStatus === 1" class="no"
                                ><i class="fas fa-times-circle"></i> Brak udziału</span
                            >
                        </div>
                    </div>
                </template>
                <template v-else-if="playerStatus === 2 || playerStatus === 3">
                    <span class="no">{{ playerStatusInfo[playerStatus] }}</span>
                </template>
                <template v-else>-</template>
            </template>
            <template v-else-if="header.value === 'classification' || header.value === 'ageCategory'">
                <span v-if="item[header.value] === '' || item[header.value] === null" class="no"
                    ><i class="fas fa-exclamation-triangle"></i
                ></span>
                <span v-else>{{ item[header.value] }}</span>
            </template>
            <template v-else-if="header.value === 'gender'">
                <span v-if="genderIssue" class="issue"><i class="fas fa-exclamation-triangle"></i></span>
                {{ item[header.value] }}
            </template>
            <template v-else-if="header.value === 'frontColumn'">
                {{ item['frontInfo'] }}
            </template>
            <template v-else>
                <template v-if="typeof item[header.value] === 'string'">{{
                    item[header.value].toLowerCase()
                }}</template>
                <template v-else>{{ item[header.value] }}</template>
            </template>
        </td>
    </tr>
</template>

<script>
    import { mapActions } from 'vuex';
    import { UPDATE_PLAYERS } from '@/store/actions.type';
    import PanelInputSwitchMini from '@/components/PanelInputSwitchMini';

    export default {
        name: 'PanelCompetitionListTableRow',
        components: {
            PanelInputSwitchMini,
        },
        props: {
            item: {
                type: Object,
                required: true,
            },
            headersDefault: {
                type: Array,
                required: true,
            },
            index: {
                type: Number,
                required: true,
            },
            openedIndex: {
                type: [Number, Boolean],
                required: false,
                default: -1,
            },
            competitionId: {
                type: Number,
                required: true,
            },
            competitionName: {
                type: String,
                required: true,
            },
            lp: {
                type: Number,
                required: true,
            },
        },
        data() {
            return {
                hover: false,
                pendingCount: 0,
                requestSeq: {
                    status: 0,
                    pay: 0,
                    payNumber: 0,
                    isAnonymous: 0,
                    playerNumber: 0,
                    playerChip: 0,
                    playerGpsNumber: 0,
                },
                state_number: {
                    submitted: false,
                    accepted: false,
                    wrong: false,
                },
                state_chip: {
                    submitted: false,
                    accepted: false,
                    wrong: false,
                },
                state_gps: {
                    submitted: false,
                    accepted: false,
                    wrong: false,
                },
                playerFree: this.item.placeClassification.classificationPrices.length === 0,
                playerPay: this.item.pay,
                playerpayNumber: this.item.payNumber,
                playerisAnonymous: this.item.isAnonymous,
                playerNumber: this.item.playerNumber ? this.item.playerNumber : '',
                playerChip: this.item.playerChip ? this.item.playerChip : '',
                playerStatus: this.item.status ? this.item.status.value : null,
                playerStatusInfo: ['', '', 'DNF', 'DQ'],
                playerGpsNumber: this.item.playerGpsNumber,
            };
        },
        computed: {
            isMobile() {
                return ['sm', 'md'].includes(this.$mq);
            },
            isRefunded() {
                return this.item.refundAmount != null;
            },
            genderIssue() {
                if (
                    (this.item.gender === 'M' && this.item.firstname.slice(-1).toLowerCase() === 'a') ||
                    (this.item.gender === 'K' && this.item.firstname.slice(-1).toLowerCase() !== 'a')
                ) {
                    return true;
                }
                return false;
            },
        },
        watch: {
            item: {
                deep: true,
                handler(newItem) {
                    if (this.pendingCount > 0) return;
                    this.syncFromItem(newItem);
                },
            },
        },
        methods: {
            ...mapActions([UPDATE_PLAYERS]),
            syncFromItem(item) {
                this.playerFree = item.placeClassification.classificationPrices.length === 0;
                this.playerPay = item.pay;
                this.playerpayNumber = item.payNumber;
                this.playerisAnonymous = item.isAnonymous;
                this.playerNumber = item.playerNumber ? item.playerNumber : '';
                this.playerChip = item.playerChip ? item.playerChip : '';
                this.playerStatus = item.status ? item.status.value : null;
                this.playerGpsNumber = item.playerGpsNumber;
            },
            togglePay() {
                this.playerPay = !this.playerPay;
                this.updatePlayer({ id: this.item.id, pay: this.playerPay });
            },
            onPayInput(value) {
                this.playerPay = value;
                this.updatePlayer({ id: this.item.id, pay: value });
            },
            togglePayNumber() {
                this.playerpayNumber = !this.playerpayNumber;
                this.updatePlayer({ id: this.item.id, payNumber: this.playerpayNumber });
            },
            onPayNumberInput(value) {
                this.playerpayNumber = value;
                this.updatePlayer({ id: this.item.id, payNumber: value });
            },
            toggleIsAnonymous() {
                this.playerisAnonymous = !this.playerisAnonymous;
                this.updatePlayer({ id: this.item.id, isAnonymous: this.playerisAnonymous });
            },
            onIsAnonymousInput(value) {
                this.playerisAnonymous = value;
                this.updatePlayer({ id: this.item.id, isAnonymous: value });
            },
            toggleStatus() {
                this.playerStatus = this.playerStatus === 0 ? 1 : 0;
                this.updatePlayer({ id: this.item.id, status: this.playerStatus });
            },
            onStatusInput(value) {
                this.playerStatus = value;
                this.updatePlayer({ id: this.item.id, status: value });
            },
            requestField(payload) {
                return [
                    'status',
                    'pay',
                    'payNumber',
                    'isAnonymous',
                    'playerNumber',
                    'playerChip',
                    'playerGpsNumber',
                ].find((field) => payload[field] !== undefined);
            },
            applyResponseFields(payload, response) {
                if (payload.pay !== undefined) this.playerPay = response.pay;
                if (payload.payNumber !== undefined) this.playerpayNumber = response.payNumber;
                if (payload.isAnonymous !== undefined) this.playerisAnonymous = response.isAnonymous;
                if (payload.status !== undefined) this.playerStatus = response.status;
                if (payload.playerNumber !== undefined) {
                    this.playerNumber = response.playerNumber ? response.playerNumber : '';
                }
                if (payload.playerChip !== undefined) {
                    this.playerChip = response.playerChip ? response.playerChip : '';
                }
                if (payload.playerGpsNumber !== undefined) {
                    this.playerGpsNumber = response.playerGpsNumber;
                }
            },
            playerInputs(header) {
                let value = this.item.playerInputs.find((item) => item.input === header)
                    ? this.item.playerInputs.find((item) => item.input === header).value
                    : '';
                if (value === '1') {
                    value = `<div class="btn"><span class="yes"><i class="fas fa-check-circle"></i></span></div>`;
                } else if (value === '0') {
                    value = `<div class="btn"><span class="no"><i class="fas fa-times-circle"></i></span></div>`;
                }
                return value;
            },
            userDetails(item, header) {
                const excludeModal = [
                    'playerNumber',
                    'pay',
                    'playerChip',
                    'status',
                    'playerGpsNumber',
                    'isAnonymous',
                    'payNumber',
                ];
                if (excludeModal.includes(header)) {
                    const value = this.index === this.openedIndex ? false : this.index;
                    if (value) {
                        this.$emit('change-accordion', value);
                    }
                } else if (header === 'payLink' && !this.playerFree) {
                    this.$emit('openPayLinkModal', item);
                } else {
                    this.$emit('openUserModal', item);
                }
            },
            async updatePlayer(payload) {
                if (payload.playerNumber || payload.playerNumber === '') this.state_number.submitted = true;
                if (payload.playerChip) this.state_chip.submitted = true;
                if (payload.playerGpsNumber) this.state_gps.submitted = true;

                const field = this.requestField(payload);
                let seq = null;
                if (field) {
                    this.requestSeq[field] += 1;
                    seq = this.requestSeq[field];
                }
                this.pendingCount += 1;

                try {
                    const response = await this.UPDATE_PLAYERS(payload);
                    if (field && seq !== this.requestSeq[field]) return;

                    this.applyResponseFields(payload, response);
                    this.$emit('update', response);
                } catch (err) {
                    if (field && seq !== this.requestSeq[field]) return;

                    if (payload.playerGpsNumber) this.state_gps.wrong = true;
                    if (payload.playerNumber) this.state_number.wrong = true;
                    if (payload.playerChip) this.state_chip.wrong = true;
                    if (payload.playerNumber) this.playerNumber = this.item.playerNumber ? this.item.playerNumber : '';
                    if (payload.playerChip) this.playerChip = this.item.playerChip ? this.item.playerChip : '';
                } finally {
                    this.pendingCount -= 1;
                    setTimeout(() => {
                        this.state_number.accepted = false;
                        this.state_chip.accepted = false;
                        this.state_number.wrong = false;
                        this.state_chip.wrong = false;
                        this.state_gps.accepted = false;
                        this.state_gps.wrong = false;
                    }, 2000);
                    this.state_number.submitted = false;
                    this.state_chip.submitted = false;
                    this.state_gps.submitted = false;
                }
            },
        },
    };
</script>

<style scoped>
    form {
        display: inline-block;
    }
    .table-list__data >>> .yes {
        color: #00b60a;
    }
    .table-list__data >>> .no {
        color: #ff0b3c;
    }
    /*
.table-list__data >>> .yes {color: #50AE55;}
.table-list__data >>> .no {color: #E62E53;}
*/
    .issue {
        color: orange;
    }
    .table-list__data {
        padding: 0 0 0 12px;
        text-transform: capitalize;
    }
    .table-list__data.table-list__data--first-cell {
        padding-left: 24px;
    }
    .table-list__data--first-cell,
    .table-list__data--min-width {
        width: 100px;
    }
    .table-list__data--max-width {
        width: 100px;
    }
    .table-list__data--lp {
        width: 40px;
    }
    .table-list__row {
        height: 40px;
    }
    .table-list__row--paid,
    .table-list__row--paid .table-list__data--pay {
        background-color: #e1f9e3 !important;
    }
    .table-list__row--not__paid,
    .table-list__row--not__paid .table-list__data--pay {
        background-color: #f9dee5 !important;
    }
    .table-list__row--refunded,
    .table-list__row--refunded .table-list__data--pay {
        background-color: #fff4e4 !important;
    }
    .table-list__row.table-list__row--paid .table-list__data--first-cell {
        background-color: #e1f9e3;
    }
    .table-list__row.table-list__row--not__paid .table-list__data--first-cell {
        background-color: #f9dee5;
    }
    .table-list__row.table-list__row--refunded .table-list__data--first-cell {
        background-color: #fff4e4;
    }
    .table-list__row--active.table-list__row--paid {
        background-color: rgba(137, 216, 141, 0.6) !important;
    }
    .table-list__row--active.table-list__row--not__paid {
        background-color: rgba(255, 23, 68, 0.3) !important;
    }
    .table-list__row--active.table-list__row--refunded {
        background-color: rgba(255, 210, 90, 0.45) !important;
    }
    .table-list__row--active.table-list__row--paid .table-list__data--first-cell {
        background-color: rgba(137, 216, 141, 0.1) !important;
    }
    .table-list__row--active.table-list__row--not__paid .table-list__data--first-cell {
        background-color: rgba(255, 23, 68, 0) !important;
    }
    .table-list__row--active.table-list__row--refunded .table-list__data--first-cell {
        background-color: rgba(255, 244, 228, 0.6) !important;
    }
    .table-list__row--active.table-list__row--paid .table-list__data--pay {
        background-color: rgba(137, 216, 141, 0.1) !important;
    }
    .table-list__row--active.table-list__row--not__paid .table-list__data--pay {
        background-color: rgba(255, 23, 68, 0) !important;
    }
    .table-list__row--active.table-list__row--refunded .table-list__data--pay {
        background-color: rgba(255, 244, 228, 0.6) !important;
    }
    .table-list__data .btn.refunded span.refunded {
        color: #c37b2e;
        display: inline-flex;
        align-items: center;
        gap: 4px;
    }
    .table-list__data .btn.refunded .refund-icon {
        width: 16px;
        height: 16px;
        /* tint white svg to refund color */
        filter: invert(48%) sepia(47%) saturate(642%) hue-rotate(5deg) brightness(95%) contrast(88%);
    }
    .table-list__data >>> .btn {
        border: 1px solid transparent;
        border-radius: 4px;
        height: 32px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 0 8px;
    }
    .table-list__data >>> .btn.active {
        border-color: #455a64;
        color: #455a64;
    }
    .table-list__data >>> .btn.active.yes {
        border-color: #50ae55;
        background-color: #50ae55;
    }
    .table-list__data >>> .btn.active.no {
        border-color: #e62e53;
        background-color: #e62e53;
    }
    .table-list__data >>> .btn.active.yes > span,
    .table-list__data >>> .btn.active.no > span {
        color: #fff;
    }
    .inputWrap {
        position: relative;
        height: 40px;
        background: #fff;
        box-shadow: 0px 8px 12px rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        margin-left: -12px;
    }
    .inputWrap input {
        height: 100%;
        box-sizing: border-box;
        border: none;
        padding-left: 12px;
    }
    .inputWrap button {
        width: 40px;
        height: 40px;
        background-color: #546e7a;
        border: none;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        color: #fff;
    }
    .inputWrap button.accepted {
        background: #50ae55;
    }
    .inputWrap button.wrong {
        background: #e62e53;
    }
    .ellipis {
        white-space: nowrap;
        width: 160px;
        text-overflow: ellipsis;
        display: inline-block;
        overflow: hidden;
    }
    .table-list__row--active .btn.active.yes,
    .table-list__row--active .btn.active.no {
        border-color: #455a64;
        background-color: transparent;
        color: #455a64;
    }
    .table-list__row--active .btn.active.yes > span,
    .table-list__row--active .btn.active.no > span {
        color: #455a64;
    }
    .flex-wrap {
        display: flex;
        align-items: center;
    }
    .flex-wrap > div:not(:last-child) {
        padding-right: 12px;
        margin-right: 12px;
        border-right: 1px solid rgba(0, 0, 0, 0.1);
    }
    .table-list__data--pay {
        box-shadow: inset 1px 1px 0 0 #e0e0e0;
    }
    @media (max-width: 991px) {
        .table-list__data--first-cell {
            padding-top: 4px;
        }
        .inputWrap {
            height: 32px;
            border-radius: 4px;
            overflow: hidden;
        }
        .inputWrap input {
            width: 48px;
            padding: 0 4px;
        }
    }
    @media (min-width: 992px) {
        .inputWrap input {
            width: calc(100% - 40px);
        }
        .table-list__data--pay {
            position: sticky;
            right: 0;
        }
    }
</style>
